<p-dialog styleClass="custom-snmp-entry-dialog" appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" 
		  [style]="{'width': '600px', 'height': '600px'}" [resizable]="false">

	<p-header>
		<span>SNMP OID Monitor</span>
	</p-header>

	<div style="overflow: hidden;">
		<form [formGroup]="settingsForm">

			<div class="col-lg-12 mb-2">
				<div class="form-group row">
					<fieldset>
						<legend>SNMP OID</legend>
					</fieldset>
				</div>
			</div>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="label-1">
							<span>OID:</span>
						</div>
						<div>
							<input type="text" pInputText class="text-field" [formControl]="oid" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="label-1">
							<span>Name:</span>
						</div>
						<div>
							<input type="text" pInputText class="text-field" [formControl]="name" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 mb-4">
				<div class="form-group row">
					<div class="uv-row">
						<div class="label-1">
							<span>Category:</span>
						</div>
						<div>
							<input type="text" pInputText class="text-field" [formControl]="category" />
						</div>
					</div>
				</div>
			</div>
			<fieldset>
				<legend>
					<input type="radio" name="options" value="1" [checked]="OptionEquals('1')" [formControl]="option"
							(change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Collect Only</span>
				</legend>
			</fieldset>
			<fieldset>
				<legend>
					<input type="radio" name="options" value="2" [checked]="OptionEquals('2')" [formControl]="option"
							(change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Use Expected Value</span>
				</legend>
			</fieldset>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="spacer"></div>
						<div class="label-2">
							<span>Expected Value:</span>
						</div>
						<div>
							<input type="text" pInputText class="text-field" [formControl]="expectedValue" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="spacer"></div>
						<input type="checkbox" [formControl]="expectedValueUseNotEqual" />
						<span class="uv-checkbox-label">Verify NOT Equal</span>
					</div>
				</div>
			</div>
			<fieldset>
				<legend>
					<input type="radio" name="options" value="3" [checked]="OptionEquals('3')" [formControl]="option"
							(change)="enableDisableControls()" />
					<span class="uv-checkbox-label">Use Thresholds</span>
				</legend>
			</fieldset>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="spacer"></div>
						<div class="label-2">
							<span>Critical:</span>
						</div>
						<div>
							<input type="number" pInputText class="number-field" [formControl]="criticalThreshold" />
						</div>
						<div class="label-2 row-gap">
							<span>Warning:</span>
						</div>
						<div>
							<input type="number" pInputText class="number-field" [formControl]="warningThreshold" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 mb-3">
				<div class="form-group row">
					<div class="uv-row">
						<div class="spacer"></div>
						<input type="checkbox" [formControl]="thresholdsUseLessThan" />
						<span class="uv-checkbox-label">Alert When Less Than (&lt;)</span>
					</div>
				</div>
			</div>

		</form>
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" [disabled]="!isSaveEnabled()" (click)="onSaveClicked()" label="Save"></button>
		<button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
	</p-footer>

</p-dialog>
